export const style = {
  '& .label': {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '24px',
    margin: '3rem 0 1rem 0'
  },
  '& .logoIcon': {
    borderColor: 'lightGrey',
    borderRadius: '50%',
    marginLeft: '1rem',
    width: '8rem',
    height: '8rem',
    marginTop: '0.8rem',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    padding: 0,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  }
};
